export const viewModes = {
    list: 'list',
    grid: 'grid',
};
